import React, { useState, useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { FaPlus } from "react-icons/fa";
import PageHeaderV2 from "../../../pageheaderV2/PageHeaderV2";
import { CurrentUserContext } from "../../../../App";
import Select from "../../../material/select/SelectV2";
import InputV2 from "../../../material/input/InputV2";
import CheckBoxV2 from "../../../material/checkboxV2/CheckBoxV2";
import * as adminApi from "../../../../service/adminApi";
import { RedirectCode400 } from "../../../RedirectCode400";

function AddQuestionnaire() {
  const { setIsMessage } = useContext(CurrentUserContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [title, setTitle] = useState("เพิ่มแบบสอบถาม");

  const [inputs, setInputs] = useState({
    title: location.state?.title || "",
    question: location.state?.question || [
      {
        type: "",
        question: "",
        require: false,
        active: true,
      },
    ],
    active: location.state?.active || true,
  });

  useEffect(() => {
    if (location.state?.id) {
      setInputs({
        title: location.state?.title ?? "",
        question: location.state?.question ?? [],
        active: location.state?.active ?? true,
      });
      setTitle("แก้ไขแบบสอบถาม");
    }

    if (location.state?.type !== "questionnaire") {
      navigate("/");
    }

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [location.state, navigate]);

  const addInput = () => {
    setInputs((prev) => ({
      ...prev,
      question: [
        ...prev.question,
        { type: "", question: "", require: false, active: true },
      ],
    }));
  };

  const deleteInput = (index) => {
    setInputs((prev) => ({
      ...prev,
      question: prev.question.filter((_, i) => i !== index),
    }));
  };

  const handleChange = (index, field, value) => {
    setInputs((prev) => ({
      ...prev,
      question: prev.question.map((input, i) =>
        i === index ? { ...input, [field]: value } : input,
      ),
    }));
  };

  const handleCheckboxChange = (index, value) => {
    handleChange(index, "require", value);
  };

  const toggleActiveQuestion = (index, value) => {
    handleChange(index, "active", value);
  };

  const toggleActiveQuestionnaire = (value) => {
    setInputs((prev) => ({ ...prev, active: value }));
  };

  const typeOptions = [
    { name: "ข้อความตัวอักษรหลายบรรทัด", value: "LINES" },
    { name: "เรตติ้ง (ดาว 5 คะแนน)", value: "STAR" },
  ];

  const addQuestionnaire = async () => {
    let res = await adminApi.addQuestionnaire(inputs);
    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({
          type: "success",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
        navigate("/admin/management/questionnaire");
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const updateQuestionnaire = async () => {
    let res = await adminApi.editQuestionnaire(location.state?.id, inputs);
    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({
          type: "success",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
        navigate("/admin/management/questionnaire");
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const onSubmit = () => {
    if (!inputs.title) {
      return setIsMessage({ type: "warning", data: "กรุณากรอกหัวข้อ" });
    }

    if (!inputs.question || inputs.question.length === 0) {
      return setIsMessage({ type: "warning", data: "กรุณากรอกคำถาม" });
    }

    location.state?.id ? updateQuestionnaire() : addQuestionnaire();
  };

  return (
    <div className="min-w-[708px] overflow-x-auto">
      <PageHeaderV2 titlename={`${title}`} />
      <div className="flex flex-col justify-center items-start w-full gap-[20px]">
        <div className="rounded-[6px] border-[#E2E2E4] border w-full min-w-[400px] p-[17px_16px]">
          <div className="mb-[10px] flex justify-start items-center">
            <span>ชื่อแบบสำรวจความพึงพอใจ</span>
          </div>
          <InputV2
            placeholder="เพิ่มแบบสำรวจความพึงพอใจ"
            value={inputs.title}
            onChangeEvt={(value) =>
              setInputs((prev) => ({ ...prev, title: value }))
            }
          />
          {inputs.question.map((input, index) => (
            <div
              key={index}
              className="flex flex-col bg-[#ECF7F3] p-[17px_16px] mt-[10px]"
            >
              <div className="flex justify-end items-center">
                <button
                  onClick={() => deleteInput(index)}
                  className="text-[#747081] text-[20px]"
                >
                  x
                </button>
              </div>
              <div className="flex flex-row gap-[16px] w-full mb-[10px] text-[#747081] md:flex-col">
                <div className="flex flex-col w-full">
                  คำถาม
                  <InputV2
                    placeholder="กรอกคำถาม"
                    value={input.question}
                    onChangeEvt={(value) =>
                      handleChange(index, "question", value)
                    }
                  />
                </div>
                <div className="flex flex-col w-[400px]">
                  ประเภท
                  <Select
                    value={input.type}
                    setValue={(value) => handleChange(index, "type", value)}
                    list={typeOptions}
                    placeholder="เลือกประเภท"
                  />
                </div>
              </div>

              <div className="flex flex-row gap-[16px] w-full mb-[10px] text-[#747081] md:flex-col">
                <div className="flex flex-col w-[250px] justify-center items-start gap-[5px]">
                  <div className="flex items-center mt-[10px]">
                    <CheckBoxV2
                      id={`checkbox-${index}`}
                      value={input.require}
                      setValue={(value) => handleCheckboxChange(index, value)}
                    />
                    <div className="ml-[5px]">จำเป็นต้องกรอก</div>
                  </div>
                  <div className="flex items-center">
                    <CheckBoxV2
                      id={`active-question-${index}`}
                      value={input.active}
                      setValue={(value) => toggleActiveQuestion(index, value)}
                    />
                    <label
                      htmlFor={`active-question-${index}`}
                      className="ml-[5px]"
                    >
                      {input.active ? "Active" : "InActive"}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          ))}
          <div className="flex w-full items-center justify-between mt-[10px]">
            <div className="flex items-center">
              <CheckBoxV2
                id="active-questionnaire"
                value={inputs.active}
                setValue={toggleActiveQuestionnaire}
                className="cursor-pointer"
              />
              <label
                htmlFor="active-questionnaire"
                className="ml-[5px] text-[#747081] text-[16px]"
              >
                {inputs.active ? "Active" : "InActive"}
              </label>
            </div>
            <button
              onClick={addInput}
              className="bg-[#70B9F0] text-white rounded-[4px] p-[6px_8px] flex items-center gap-[5px] cursor-pointer"
            >
              <FaPlus />
              เพิ่มคำถาม
            </button>
          </div>
        </div>
        <div className="flex justify-end mt-[10px] w-full gap-[5px]">
          <button
            onClick={() => navigate("/admin/management/faq")}
            className="rounded-[5px] bg-[#C0C0C0] h-[40px] w-[94px] text-[#FFFFFF] cursor-pointer"
          >
            ยกเลิก
          </button>
          <button
            onClick={onSubmit}
            className="rounded-[5px] bg-[#2EA669] h-[40px] w-[94px] text-[#FFFFFF] cursor-pointer"
          >
            บันทึก
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddQuestionnaire;
